import { render, staticRenderFns } from "./cooperationMedia.vue?vue&type=template&id=5b282163&scoped=true"
import script from "./cooperationMedia.vue?vue&type=script&lang=js"
export * from "./cooperationMedia.vue?vue&type=script&lang=js"
import style0 from "./cooperationMedia.vue?vue&type=style&index=0&id=5b282163&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b282163",
  null
  
)

export default component.exports